/// <amd-module name="Wit/WorkItemBuildLinks/Components/BuildsPreviewTable" />
import * as React from "react";
import { useMemo } from "react";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { ColumnSelect, ITableColumn, renderSimpleCell, renderSimpleCellValue, Table } from "VSSUI/Table";
import { IListSelection } from "VSSUI/List";
import { Build } from "Build/Client/Contracts/Build";
import * as Resources from "Wit/WorkItemBuildLinks/Resources";

export interface IBuildsPreviewTableProps {
    builds: Build[];
    selection: IListSelection;
}

// The table typings require an index signature even though it is not actually needed.
type BuildListItem = Build & Record<string, any>;

export function BuildsPreviewTable({ builds, selection }: IBuildsPreviewTableProps) {
    const columns = useMemo(() => getTableColumns(), []);
    return (
        <Table
            itemProvider={new ArrayItemProvider(builds as BuildListItem[])}
            selection={selection}
            columns={columns}
            virtualize={false /* at most 50 rows*/}
        />
    );
}

function getTableColumns() {
    return [
        new ColumnSelect(),
        {
            id: "buildNumber",
            name: Resources.BuildsPreviewTableNameColumn,
            readonly: true,
            renderCell: renderSimpleCell,
            width: -25
        },
        {
            id: "definition.name",
            name: Resources.BuildsPreviewTablePipelineColumn,
            readonly: true,
            renderCell: (_rowIndex: number, colIndex: number, column: ITableColumn<BuildListItem>, item: BuildListItem) =>
                renderSimpleCellValue(colIndex, column, item.definition.name),
            width: -25
        },
        {
            id: "sourceBranch",
            name: Resources.BuildsPreviewTableSourceColumn,
            readonly: true,
            renderCell: renderSimpleCell,
            width: -25
        },
        {
            id: "finishTime",
            name: Resources.BuildsPreviewTableDateCompletedColumn,
            readonly: true,
            renderCell: renderSimpleCell,
            width: -25
        }
    ];
}
